import { Component, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  imports: [NgTemplateOutlet, TranslateDirective],
})
export class LoadingSpinnerComponent {
  @Input() spinnerTextKey: string;
}
